import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';

const InstallPWAPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      const dismissed = localStorage.getItem('install_pwa_dismissed');
      if (dismissed) {
        const at = parseInt(dismissed);
        if (Date.now() - at < 14 * 24 * 60 * 60 * 1000) return;
      }
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    localStorage.setItem('install_pwa_dismissed', Date.now().toString());
    setDeferredPrompt(null);
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem('install_pwa_dismissed', Date.now().toString());
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-24 left-4 right-4 z-50 max-w-md mx-auto bg-gradient-to-r from-primary to-accent text-white rounded-2xl shadow-2xl p-4 animate-in slide-in-from-bottom">
      <div className="flex items-center gap-3">
        <Download className="w-6 h-6 flex-shrink-0" />
        <div className="flex-1">
          <p className="font-['Outfit'] font-bold">Instale o Beach Pay!</p>
          <p className="text-xs text-white/80">Acesso rápido direto da tela inicial</p>
        </div>
        <button
          data-testid="install-pwa"
          onClick={install}
          className="px-3 py-1.5 bg-white text-primary rounded-full text-sm font-bold"
        >
          Instalar
        </button>
        <button onClick={dismiss} className="p-1 hover:bg-white/10 rounded-full">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallPWAPrompt;
